<template>
  <ModalCardDefault :title="'Listar Pagamentos'" @close="close">
    <ExpansionPanel
      v-model="panel"
      :title="'Listar Pagamentos'"
      :icon="$icons.box"
      readonly
    >
      <DataTable
        no-search
        :items="item.companies[0].subscriptions[0].payments"
        :headers="headers"
        :items-per-page="5"
        :slots="slotsItems"
        no-sync
      >
        <template v-slot:[`due_date`]="{ props: { item } }">
          {{ utils.formatDatePT(item.due_date) }}
        </template>

        <template v-slot:[`start_date`]="{ props: { item } }">
          {{ utils.formatDatePT(item.start_date) }}
        </template>

        <template v-slot:[`end_date`]="{ props: { item } }">
          {{ utils.formatDatePT(item.end_date) }}
        </template>

        <template v-slot:[`payment_method`]="{ props: { item } }">
          {{ getPaymentMethod(item.payment_method) }}
        </template>

        <template v-slot:[`payment_date`]="{ props: { item } }">
          {{ utils.formatDatePT(item.payment_date) }}
        </template>

        <template v-slot:[`value`]="{ props: { item } }">
          {{ utils.formatCurrency(item.value) }}
        </template>

        <template v-slot:[`status`]="{ props: { item } }">
          <Chip
              :label="getStatus(item.status)"
              small
              :color="getStatusColorChip(item.status)"
            />
        </template>
      </DataTable>
    </ExpansionPanel>
  </ModalCardDefault>
</template>

<script>
import ModalCardDefault from '@/components/ModalCardDefault';
import {
  ExpansionPanel,
  Row,
  Col,
  TextField,
  Select,
  Button,
  Dialog,
  DataTable,
  Chip,
} from '@/components/vuetify';
import { formatDatePT, formatCurrency } from '@/utils';

export default {
  name: 'GenerateProductInvoice',
  components: {
    ModalCardDefault,
    ExpansionPanel,
    Row,
    Col,
    TextField,
    Select,
    Button,
    Dialog,
    DataTable,
    Chip,
  },
  props: {
    item : {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    panel: [0],
    validForm: false,
    loading: false,
    utils: {
      formatDatePT,
      formatCurrency,
    },
  }),
  computed: {
    slotsItems() {
      return [
        { field: 'due_date' },
        { field: 'start_date' },
        { field: 'end_date' },
        { field: 'payment_method' },
        { field: 'status' },
        { field: 'value' },
        { field: 'payment_date' },
      ]
    },
    headers() {
      return [
        { text: 'Vencimento', value: 'due_date' },
        { text: 'Início Vigência', value: 'start_date' },
        { text: 'Fim Vigência', value: 'end_date' },
        { text: 'Forma Pagamento', value: 'payment_method' },
        { text: 'Valor', value: 'value' },
        { text: 'Data Pag.', value: 'payment_date' },
        { text: 'Status', value: 'status' },
      ];
    },
  },
  watch: {},
  mixins: [],
  methods: {
    getPaymentMethod(paymentMethod) {
      return paymentMethod;
    },
    getStatus(status) {
      return status === 'paid' ? 'Pago' : 'Pendente';
    },
    getStatusColorChip(status) {
      return status === 'paid' ? 'success' : 'warning';
    },
    close() {
      this.$emit('close');
    },
  },
  mounted() {
  },
};
</script>

<style></style>
